var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn num-btn",attrs:{"id":"NUMBER_2","name":"2","data-vcode":"NUMBER_2","aria-label":"2 ABC"}},[_c('div',{staticClass:"digit"},[_vm._v("2")]),_c('div',{staticClass:"letters"},[_vm._v("ABC")])])
}]

export { render, staticRenderFns }